import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_burger",
  "use": "icon_burger-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 48 48\" id=\"icon_burger\"><path fill=\"currentColor\" d=\"M0 6a3 3 0 013-3h42a3 3 0 110 6H3a3 3 0 01-3-3zm0 18a3 3 0 013-3h42a3 3 0 110 6H3a3 3 0 01-3-3zm3 15a3 3 0 100 6h42a3 3 0 100-6H3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol